import React, { useRef, useState, useEffect, useContext } from 'react';
import AuthContext from './context/AuthProvider';
import axios from 'axios';
import { Helmet} from 'react-helmet';
import { Formulario, MensajeExito, MensajeError, ContenedorBotonCentrado, BotonAmarillo} from './elementos/FormFicha';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Footer } from './elementos/Footers';
import Ficha from './componentes/Ficha';
import { BodyLogin } from './elementos/FormLogin';
import { Navigate } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";
 
  const baseUrlGDO = process.env.REACT_APP_URL_API_GDO;
  const Login = () =>{
  const { setAuth } = useContext(AuthContext);
  const userRef = useRef();
  const errRef = useRef();
  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const [guid, setGuID] = useState('');
  const [Usuarios, setUsuarios] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [jwtUsuario, setJwtUsuario] = useState('');

  const [searchParams, setSearchParams] = useSearchParams();

  var guid_oportunidad = searchParams.get("guid"); 
  var usuarios = searchParams.get("usuarioAdministrativo");//6a1d2667-1929-ec11-b6e6-0022483751cf
  var version_crm = searchParams.get("crm");
  
  /*
  useEffect(() => {
    userRef.current.focus(); 
  },[])*/

  useEffect(() => {
  setErrMsg('');
  }, [user, pwd])

  if(guid_oportunidad!=null && usuarios!=null && version_crm!=null){

    var URI="/FichaMatricula?guid=" + guid_oportunidad + "&usuarioAdministrativo=" + usuarios + "&crm="+version_crm;
    return <Navigate to={URI} />
  }  


    const handleSubmit = async (e) => { 
    e.preventDefault();
    try  {
          const response = await axios.post(baseUrlGDO + 'api/cuentas/autenticar',
          JSON.stringify({ "login": user, "password": pwd }),
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
          });
  
      const guid_oport= response?.data.guid_oportunidad;
      const version_crm=response?.data.version_crm;
      const jwt_Usuario=response?.data.jwt;
      setJwtUsuario(response?.data.jwt);
      //se guardara en un localstorage
      localStorage.setItem("GUID", guid_oport);
      localStorage.setItem("user",user);
      localStorage.setItem("version_crm",version_crm)
      localStorage.setItem("jwtUsuario",jwt_Usuario)
      const valorGuid = localStorage.getItem("GUID");
      const valoruser = localStorage.getItem("user");
      const jwtUsuario = localStorage.getItem("jwtUsuario");
      
      //setGuID(guid_oport);
      setGuID(valorGuid);
      setUsuarios(valoruser);
      setJwtUsuario(jwtUsuario);
      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      setAuth({ user, pwd, roles, accessToken });
      setUser('');
      setPwd('');  
      setSuccess(true);   
    } 
    catch (err)
    { 
      setSuccess(false);    
      if(!err?.response){         
        setErrMsg('No hay respuesta del servidor');
      } else if(!err.response?.status === 400){
        setErrMsg('Usuario o Contraseña incorrecta');
      } else if(!err.response?.status === 401){
        setErrMsg('No está autorizado');
      } else {
        setErrMsg('Usuario y/o Contraseña incorrectas');
      }
      errRef.current.focus();
    }
  }
   
   if (success==true) 
   {
     return <Navigate to="/ficha" />
   } 
    
  return (
    <>
   
          <Helmet>
            <title>Login</title>
          </Helmet>

      {success ==true ? (
        <section>
          <Ficha
            guid_oportunidad = {guid}            
            usuarios={Usuarios}
            jwtUsuario={jwtUsuario}
          />
        </section>
      ):(
      <>
       
      <br/><br/>    <br/>    
          <BodyLogin className = "text-center">  
        
               {/* <Container> */}
          <Formulario  onSubmit={handleSubmit}>
            
            <img src={('https://upn-repositorio-public.s3.amazonaws.com/logos/png/logo-upn-sin-fondo.png')}
             width="160px"
             align-content= "center" />
                    
            <br /><br />
            <p style={{ backgroundColor: '#f8d7da'}} ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
           
            <input
              type = "text"
              id = "username"
              ref = {userRef}
              autoComplete = "off"
              onChange = {(e)=>setUser(e.target.value)}
              value = {user}
              required
            />
            <input
              type = "password"
              id = "password"
              onChange = {(e)=>setPwd(e.target.value)}
              value = {pwd}
              required
            />
            {false && 
            <MensajeError>
                  <>
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    <b>Error:</b> Por favor rellena el formulario correctamente.
                  </>
            </MensajeError>
            }
            <ContenedorBotonCentrado>
              <BotonAmarillo type="submit">Ingresar</BotonAmarillo>
              <MensajeExito>Formulario enviado exitosamente!</MensajeExito>
            </ContenedorBotonCentrado>
          </Formulario>
      
      {/* </Container>   */}
      <Footer>
       <p>© 2022 Universidad Privada del Norte</p>
      </Footer>        
      </BodyLogin>  
            
      </>
      )}
      
    </>
  );
}
export default Login;